import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { validatorConsultaSeguimentoOutro } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta12Model } from './model-consultaSeguimentoPergunta12'
import {
  hasPergunta12ExemplosAtLeastTwoSim,
  hasPergunta12ExemplosFalhouAnySim,
  hasPergunta12ExemplosPassouAnySim,
  isPergunta12ExemplosAllFilled,
  isPergunta12ExemplosPassouFalhouAllFilled,
} from './utils-consultaSeguimentoPergunta12'

export const validatorConsultaSeguimentoPergunta12 = createValidator<ConsultaSeguimentoPergunta12Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_12_HEADER: required,
    OUTRO: validatorConsultaSeguimentoOutro,
  },
  (values: ConsultaSeguimentoPergunta12Model, errors: ErrorObject<ConsultaSeguimentoPergunta12Model>) => {
    if (values?.PERGUNTA_12_HEADER === SimNaoEnum.SIM) {
      const isExemplosAllFilled = isPergunta12ExemplosAllFilled(values)
      const hasExemplosAtLeastTwoSim = hasPergunta12ExemplosAtLeastTwoSim(values)

      if (!isExemplosAllFilled && !hasExemplosAtLeastTwoSim) {
        errors.PERGUNTA_12_EXEMPLOS = pergunta12ExemplosValidator(values.PERGUNTA_12_EXEMPLOS)
      }

      if (hasExemplosAtLeastTwoSim) {
        const isExemplosAllFilledPassouFalhou = isPergunta12ExemplosPassouFalhouAllFilled(
          values?.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU
        )

        if (!isExemplosAllFilledPassouFalhou) {
          errors.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU = pergunta12ExemplosPassouFalhouValidator(
            values.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU
          )
        }
        const hasPassouAnySim = hasPergunta12ExemplosPassouAnySim(values?.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)
        const hasFalhouAnySim = hasPergunta12ExemplosFalhouAnySim(values?.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)

        if (hasPassouAnySim && hasFalhouAnySim) {
          errors.PERGUNTA_12_FREQUENCIA = required(values?.PERGUNTA_12_FREQUENCIA)
        }
      }
    }

    return errors
  }
)
const pergunta12ExemplosValidator = createValidator<ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS']>({
  MAQUINA_DE_LAVAR: required,
  CHORO_DE_BEBES: required,
  ASPIRADOR_DE_PO: required,
  SECADOR_DE_CABELO: required,
  TRANSITO: required,
  GRITO_DE_BEBES: required,
  MUSICA_ALTA: required,
  TOQUE_TELEFONE_CAMPAINHA: required,
  BARULHO_DE_LIQUIDIFICADOR: required,
  LUGARES_BARULHENTOS: required,
})

const pergunta12ExemplosPassouFalhouValidator = createValidator<
  ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
>({
  FALHOU: createValidator<ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']['FALHOU']>({
    GRITA: required,
    CHORA: required,
    TAMPA_OUVIDOS: required,
  }),
  PASSOU: createValidator<ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']['PASSOU']>({
    TAMPA_OUVIDOS_CALMAMENTE: required,
    NAO_GOSTA_BARULHO: required,
  }),
})
